import axios from 'axios'
import constants from '../../../constants'

export const triggerDemo = async (demoMode: string, customerNumber: string) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/demos/triggerDemo`, { demoMode })
  return data
}

export const sendTbrItems = async (customerNumber: string) => {
  const date = new Date()
  date.setMonth(date.getMonth() + 3)
  const itemNumbers = ['1003580', '1003600', '1005860', '1005870', '1005880']
  const data = itemNumbers.map(itemNumber => (
    {
      customerNumber: customerNumber,
      itemId: itemNumber,
      quantity: 1,
      frequency: 2,
      hold: false,
      startDate: date,
    }
  ))

  await axios.post(constants.SUBSCRIPTION_SERVICE_URL, { data })
}